import { StdioServerTransport } from "@modelcontextprotocol/sdk/server/stdio.js";

import { runCli } from "./cli.js";
import { runHealthCheck } from "./health/index.js";
import { LazyProjectSyncSource } from "./runtime.js";
import { createPrimeUiMcpServer } from "./server.js";

async function startPrimeUiMcpServer(): Promise<void> {
  const source = new LazyProjectSyncSource();
  const server = createPrimeUiMcpServer(source);

  const transport = new StdioServerTransport();
  await server.connect(transport);
}

async function main(): Promise<void> {
  const exitCode = await runCli(process.argv.slice(2), {
    stdout: process.stdout,
    stderr: process.stderr,
    startServer: startPrimeUiMcpServer,
    runHealthCheck: ({ projectRoot }) =>
      runHealthCheck({
        projectRoot,
        stdout: process.stdout,
        env: process.env,
        cwd: process.cwd(),
      }),
  });

  if (exitCode !== 0) {
    process.exitCode = exitCode;
  }
}

main().catch((error) => {
  console.error("[primeui-mcp] failed to start", error);
  process.exit(1);
});
